import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Container, ListLayout, ListImg, CustomLink } from "@/components"
import t from "@/constants/wording"
import * as styles from "./index.module.scss"

const CertificationType: React.FC = () => {
  const data = useStaticQuery<CertificationTypeQuery>(graphql`
    query StrapiCertificationTypeQuery {
      allStrapiEducationCertificationCards(
        limit: 3
        sort: { fields: order, order: ASC }
      ) {
        nodes {
          id
          image {
            media {
              width
              height
              url
            }
            alt
          }
          title
          description
          link
        }
      }
    }
  `)

  const certificationType: CertificationType[] =
    data.allStrapiEducationCertificationCards.nodes || []

  return (
    <>
      {certificationType && certificationType.length > 0 && (
        <div className={`common-region-grey ${styles.certificationType}`}>
          <Container>
            <h1 className="common-h1-title">{t("certification type")}</h1>
            <ListLayout listData={certificationType}>
              {item => (
                <div className="common-card-content">
                  <ListImg
                    className={styles.imgContent}
                    imgInfo={item.image}
                    scale={[416, 200]}
                  />
                  <div className={styles.inner}>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                  <div className={styles.btnContent}>
                    {item.link ? (
                      <CustomLink
                        linkTo={item.link}
                        className="button is-primary"
                      >
                        {t("certification immediately")}
                      </CustomLink>
                    ) : (
                      <button className="button" disabled>
                        {t("stay tuned for")}
                      </button>
                    )}
                  </div>
                </div>
              )}
            </ListLayout>
          </Container>
        </div>
      )}
    </>
  )
}

export default CertificationType
